import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import * as Const_SMS010 from '@pages/sms010-completed/sms010-completed-const';
import {Title,} from '@angular/platform-browser';
import {MessageLevel,} from '@models/index';

@Component({
  selector: 'app-sms010-completed',
  templateUrl: './sms010-completed.html',
  styleUrls: ['./sms010-completed.scss',],
})
/*****************************************************/
/* 処　理：SMS010 手続き完了 画面
/*
/* 概　要：手続完了 処理
/*
/* 更新日：2025/03/12 HARAGU 00011_SMS機能等の導入支援_#10094
/*****************************************************/
export class SMS010Completed implements OnInit {
  smsForm!: FormGroup;            // 画面フォーム
  loginUserVO!: LoginUserVO;      // セッション情報
  dispId!: string;                // ログ表示用ID
  lngType!: string;               //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // 画面項目（ラベル入れ替え用）
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblBtnMenu!: string;

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS01001M003E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
    });

    // 初期表示
    this.formInit();
  }

  /**
   * 初期表示
   */
  formInit(): void {

    try {
      // ログ出力
      this.logger.info('SMS01001M001I', this.dispId, Const_SMS010.INIT_NAME);

      // 画面文言（言語区分により変換）
      // 登録完了
      this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS010' + this.lngType + 'M001F',},  false) || '';
      // お手続きが完了しました。
      this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS010' + this.lngType + 'M002F',},  false) || '';
      // メニューへ戻る
      this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS010' + this.lngType + 'M003F',},  false) || '';

      // ブラウザ・ヘッダータイトル
      const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
      this.titleService.setTitle(companyName);
      document.getElementById('lblScreenTitle')!.innerText = '';

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS01001M002I', this.dispId, Const_SMS010.INIT_NAME);

      // 初期化（ログイン情報）
      this.windowService.removeItemFromLocalStorage('accToken');
      this.windowService.removeItemFromLocalStorage('loginInfo');

    } catch (ex) {
      this.logger.error('SMS01001M001E', this.dispId, Const_SMS010.INIT_NAME);
      this.commonException(ex);
    }
  }

  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS01001M003I', this.dispId, Const_SMS010.BTN_BACKMENU_NAME);

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS01001M002E', this.dispId, Const_SMS010.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 10 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

}
